import React, {useEffect, useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import {Link, useNavigate} from 'react-router-dom';
import AttributeUtil from "../../../../../../utils/orders/AttributeUtil";
import OrderUtil from "../../../../../../utils/orders/OrderUtil";
import MenuItem from "@mui/material/MenuItem";
import FilterUtil from "../../../../../../utils/common/FilterUtil";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {ruRU} from "@mui/x-date-pickers/locales";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import Box from "@mui/material/Box";
import ButtonCreate from "../../../../button/ButtonCreate";
import {Tooltip} from "@mui/material";
import DateRangeFilter from "../../../../filter/DateRangeFilter";
import OrderFolderNameCell from "../order/OrderFolderNameCell";

const ArchiveTable = ({
                          data, setData, customerList, nameList, modelList, attributeList,
                          planningList, constructorList, technologistList,
                          numberList, numberCustomerList,
                          tableOptions, tableOptionsHandle, notImplemented, globalFilter,
                          handleSearchQuery,
                          filteredData, columnsFilter
                      }) => {
    const navigate = useNavigate();
    const [showColumnFilters, setShowColumnFilters] = useState(false)

    const handleShowColumnFilters = () => {
        setShowColumnFilters(!showColumnFilters)
        if (showColumnFilters) {
            handleSearchQuery([], data, null, true)
        }
    }

    const columns = useMemo(
        () => [
            {
                id: 'number',
                header: '№ заказа',
                accessorKey: 'number',
                filterVariant: 'multi-select',
                filterSelectOptions: numberList,
                maxSize: 100,
                muiFilterTextFieldProps: {
                    placeholder: 'Отфильтровать по № заказа',
                    sx: {width: '200px'},
                },
                Cell: ({cell, row}) => (
                    <OrderFolderNameCell order={row.original}>
                        <Tooltip arrow placement="bottom" title={row.original.number}>
                            <Box
                                sx={{
                                    width: "130px",
                                    overflow: "clip",
                                    textOverflow: "ellipsis"
                                }}
                            >
                                <Link
                                    to={'/organization/orders/' + row.original.id + '/' + encodeURIComponent(cell.getValue()) + '/'
                                        + row.original.header.id + '/'
                                        + row.original.year}
                                >
                                    {cell.getValue() === null ? 'Не занумерован' : cell.getValue()}
                                </Link>
                            </Box>
                        </Tooltip>
                    </OrderFolderNameCell>
                ),
            },
            {
                id: 'numberCustomer',
                header: 'Номер заказчика                                             ',
                accessorKey: 'numberCustomer',
                filterVariant: 'multi-select',
                filterSelectOptions: numberCustomerList,
                maxSize: 23,
                minSize: 35,
                muiFilterTextFieldProps: {
                    placeholder: 'Отфильтровать по № заказчика',
                    sx: {width: '200px'},
                },
            },
            {
                id: 'customerOrder',
                header: 'Заказчик                                                           ',
                accessorKey: 'customerOrder.name',
                enableStickyHeader: true,
                enableStickyFooter: true,
                enableGrouping: true,
                filterVariant: 'multi-select',
                filterSelectOptions: customerList,
                muiTableBodyCellEditTextFieldProps: {
                    select: true,
                    children: customerList.map((customer) => (
                        <MenuItem key={customer} value={customer}>
                            {customer}
                        </MenuItem>
                    )),
                },
                minSize: 15,
                muiFilterTextFieldProps: {
                    placeholder: 'Отфильтровать по заказчик',
                    sx: {
                        width: '260px',
                    },
                }
            },
            {
                id: 'header',
                header: 'Наименование                                                 ',
                accessorKey: 'header.name',
                filterVariant: 'multi-select',
                filterSelectOptions: nameList,
                muiTableBodyCellEditTextFieldProps: {
                    select: true,
                    children: nameList.map((header) => (
                        <MenuItem key={header} value={header}>
                            {header}
                        </MenuItem>
                    )),
                },
                enableGrouping: true,
                minSize: 15,
                muiFilterTextFieldProps: {
                    placeholder: 'Отфильтровать по наименование',
                    sx: {
                        width: '260px',
                    },
                }
            },
            {
                id: 'model',
                header: 'Модель                                                             ',
                accessorKey: 'modelOrder.name',
                filterVariant: 'multi-select',
                filterSelectOptions: modelList,
                enableGrouping: true,
                minSize: 150,
                muiFilterTextFieldProps: {
                    placeholder: 'Отфильтровать по модель',
                    sx: {
                        width: '260px',
                    },
                }
            },
            {
                accessorFn: (row) => {
                    if (row.dateOfReceipt === null) {
                    } else {
                        return new Date(row.dateOfReceipt)
                    }
                },
                id: 'dateOfReceipt',
                header: 'Дата поступления                                           ',
                sortingFn: 'datetime',
                size: 10,
                Cell: ({cell}) => {
                    if (cell.getValue() !== undefined) {
                        return cell.getValue().toLocaleDateString('en-GB');
                    }
                },
                Filter: ({column}) => <DateRangeFilter
                    column={column}
                />,
            },
            {
                id: 'constructor',
                header: 'Констуктор                                                       ',
                accessorKey: 'constructor.name',
                enableStickyHeader: true,
                enableStickyFooter: true,
                enableGrouping: true,
                filterVariant: 'multi-select',
                filterSelectOptions: constructorList,
                muiTableBodyCellEditTextFieldProps: {
                    select: true,
                    children: constructorList.map((constructor) => (
                        <MenuItem key={constructor} value={constructor}>
                            {constructor}
                        </MenuItem>
                    )),
                },
                maxSize: 100,
                minSize: 100,
                muiFilterTextFieldProps: {
                    placeholder: 'Отфильтровать по конструктор',
                    sx: {
                        width: '260px',
                    },
                }
            },
            {
                accessorFn: (row) => {
                    if (row.dateOfConstructorDocumentation === null) {
                    } else {
                        return new Date(row.dateOfConstructorDocumentation)
                    }
                },
                id: 'dateOfConstructorDocumentation',
                header: 'Дата тех. документации конструктор           ',
                sortingFn: 'datetime',
                minSize: 250,
                Cell: ({cell}) => {
                    if (cell.getValue() !== undefined) {
                        return cell.getValue().toLocaleDateString('en-GB');
                    }
                },
                Filter: ({column}) => <DateRangeFilter
                    column={column}
                />,
            },
            {
                id: 'technologist',
                header: 'Технолог                                                           ',
                accessorKey: 'technologist.name',
                enableStickyHeader: true,
                enableStickyFooter: true,
                enableGrouping: true,
                filterVariant: 'multi-select',
                filterSelectOptions: technologistList,
                muiTableBodyCellEditTextFieldProps: {
                    select: true,
                    children: technologistList.map((technologist) => (
                        <MenuItem key={technologist} value={technologist}>
                            {technologist}
                        </MenuItem>
                    )),
                },
                maxSize: 20,
            },
            {
                accessorFn: (row) => {
                    if (row.dateOfTechnicalDocumentation === null) {
                    } else {
                        return new Date(row.dateOfTechnicalDocumentation)
                    }
                },
                id: 'dateOfTechnicalDocumentation',
                header: 'Дата тех. документации технолог                ',
                sortingFn: 'datetime',
                minSize: 250,
                Cell: ({cell}) => {
                    if (cell.getValue() !== undefined) {
                        return cell.getValue().toLocaleDateString('en-GB');
                    }
                },
                Filter: ({column}) => <DateRangeFilter
                    column={column}
                />,
            },
            {
                id: 'attributes',
                header: 'Атрибуты                                                         ',
                accessorKey: 'attributes',
                filterVariant: 'multi-select',
                filterSelectOptions: attributeList,
                filterFn: (row, id, filterValue) => {
                    return OrderUtil.checkStatus(row.getValue(id), filterValue)
                },
                minSize: 20,
                Cell: ({cell}) => (<div>{AttributeUtil.convertAttributes(cell.getValue())}</div>),
                muiFilterTextFieldProps: {
                    placeholder: 'Отфильтровать по трибуты',
                    sx: {
                        width: '260px',
                    },
                }
            },
            {
                accessorFn: (row) => {
                    if (row.manufactured === null) {
                    } else {
                        return new Date(row.manufactured)
                    }
                },
                id: 'manufactured',
                header: 'Произведено                                                   ',
                filterFn: (row, id, filterValue) => {
                    return FilterUtil.checkDate(row.getValue(id), filterValue)
                },
                sortingFn: 'datetime',
                size: 10,
                Cell: ({cell}) => {
                    if (cell.getValue() !== undefined) {
                        return cell.getValue().toLocaleDateString('en-GB');
                    }
                },
                Filter: ({column}) => <DateRangeFilter
                    column={column}
                />,
            },
            {
                accessorFn: (row) => {
                    if (row.shipped === null) {
                    } else {
                        return new Date(row.shipped)
                    }
                },
                id: 'shipped',
                header: 'Отгружено                                                        ',
                sortingFn: 'datetime',
                size: 10,
                Cell: ({cell}) => {
                    if (cell.getValue() !== undefined) {
                        return cell.getValue().toLocaleDateString('en-GB');
                    }
                },
                Filter: ({column}) => <DateRangeFilter
                    column={column}
                />,
            },
            {
                id: 'state',
                header: 'Планирование                                                 ',
                accessorKey: 'state',
                filterVariant: 'multi-select',
                filterSelectOptions: planningList,
                minSize: 6,
                maxSize: 6,
            },
            {
                id: 'year',
                header: 'год                                                                     ',
                accessorKey: 'year',
                enableColumnActions: false,
                enableGrouping: false,
                enableColumnFilter: false,
                enableEditing: false,
            },
            {
                header: 'id',
                accessorKey: 'id',
                enableHiding: false,
                enableColumnActions: false,
                enableGrouping: false,
                enableColumnFilter: false,
                enableEditing: false,
            },
        ],
        [data, setData, filteredData, customerList, nameList, modelList, attributeList, planningList, constructorList, technologistList, numberList, numberCustomerList],
    );

    return (
        <Box sx={{display: "flex", flexDirection: "column", gap: "32px"}}>
            <Box sx={{display: 'flex', gap: "10px", justifyContent: "flex-end"}}>
                {!notImplemented && <ButtonCreate
                    text={"Нереализованные"}
                    width={160}
                    icon={false}
                    onClick={() => navigate('/organization/not-implemented')}
                />}
            </Box>
            <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale='ru'
                localeText={ruRU.components.MuiLocalizationProvider.defaultProps.localeText}>
                <MaterialReactTable
                    muiTopToolbarProps={{
                        sx: {
                            "& .MuiBox-root": {
                                padding: 0
                            }
                        }
                    }}
                    muiTableBodyCellProps={{
                        sx: {
                            p: '0px 0px 0px 10px',
                            m: '0px 0px 0px 0px',
                            border: "none",
                            "&:after": {
                                display: "none",
                            },
                            "&:not(:last-of-type)": {
                                borderRight: '1px solid #EAEBEA',

                            },
                            "& a": {
                                color: "#006CCC",
                                textDecoration: "none",
                                "&:hover": {
                                    textDecoration: "underline"
                                }

                            }
                        },
                    }}
                    muiTableHeadCellProps={{
                        sx: {
                            border: '1px solid #EAEBEA',
                            backgroundColor: "#F5F6FA",
                            padding: "10px",
                            paddingBottom: " 0.2rem",
                            paddingTop: "0.2rem",
                            "&:first-of-type .Mui-TableHeadCell-Content-Wrapper": {
                                "minWidth": "100%"
                            },
                            "& .MuiCollapse-root .MuiSelect-select": {
                                padding: "0 !important",
                                "& .MuiChip-label": {
                                    paddingLeft: "5px",
                                    paddingRight: "5px",
                                }
                            }
                        },
                    }}
                    muiTableBodyRowProps={({row}) => {
                        return ({
                            sx: () => ({
                                height: '36px',
                                backgroundColor: "white",
                                "&:hover& td:after": {
                                    display: "none",
                                },
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light70,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                                "&:hover": {
                                    "& td:after": {
                                        display: "none",
                                    },
                                    backgroundColor: (theme) => theme.palette.primary.stroke,
                                },
                                '&:nth-of-type(even)': {
                                    "&.MuiTableRow-root.Mui-selected": {
                                        backgroundColor: (theme) => theme.palette.primary.light,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.light50,
                                        },
                                    },
                                    backgroundColor: (theme) => theme.palette.primary.lightGrey,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.stroke,
                                    },
                                },
                            })
                        })
                    }}

                    muiSearchTextFieldProps={{
                        placeholder: `Поиск`,
                        sx: {
                            paddingTop: "5px",
                            paddingBottom: "0px",
                            "& .MuiCollapse-root": {
                                borderRadius: '12px',
                                height: 40, width: 290,
                                "& .MuiSvgIcon-root": {
                                    color: "#737478"
                                },
                                '& .MuiOutlinedInput-input': {
                                    padding: 0
                                }
                            }
                        },
                        variant: 'outlined',
                    }}
                    columns={columns}
                    data={filteredData}
                    onPaginationChange={(updater) => {
                        tableOptionsHandle(updater(tableOptions));
                    }}
                    onGlobalFilterChange={(value) => {
                        handleSearchQuery(value, data, null)
                    }}
                    onColumnFiltersChange={(updater) => {
                        handleSearchQuery(updater(columnsFilter), data, null, true)
                    }}
                    onShowColumnFiltersChange={handleShowColumnFilters}
                    state={{
                        showColumnFilters: showColumnFilters,
                        columnFilters: columnsFilter,
                        globalFilter: globalFilter,
                        showGlobalFilter: true,
                        pagination: tableOptions,
                    }}
                    rowCount={tableOptions.totalElements}
                    manualFiltering={true}
                    initialState={{
                        columnVisibility: {
                            id: false,
                            state: false,
                            model: false,
                            year: false,
                        },
                    }}
                    getRowId={(originalRow) => originalRow.id}
                    selectAllMode={"all"}
                    renderTopToolbar={({table}) => {
                        return <Box sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "7px",
                            backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                        }}>
                            <MRT_ToolbarAlertBanner table={table}/>
                            <Box sx={{display: "flex"}}>
                                <MRT_ToggleFiltersButton table={table}/>
                                <MRT_GlobalFilterTextField table={table}/>
                            </Box>
                        </Box>
                    }}
                    muiToolbarAlertBannerProps={{
                        sx: {
                            backgroundColor: (theme) => theme.palette.primary.light,
                            "& .MuiStack-root": {
                                padding: 0,
                            },
                        }
                    }}
                    muiToolbarAlertBannerChipProps={{color: 'primary'}}
                    localization={MRT_Localization_RU}
                    enableRowActions={false}
                    enableToolbarInternalActions={false}
                />
            </LocalizationProvider>
        </Box>

    )
        ;
};

export default ArchiveTable;